define('app',[
    'bootstrap',
    'quiz_model',
    'quiz_view',
    'utils'
], function (news, QuizModel, QuizView, utils) {
    return {
        init: function (options) {
            var myQuizModel,
                myQuizView,
                data = options.data,
                vocabs = options.vocabs,
                quizInAnIframe = options.quizInAnIframe,
                iframeWrapper = options.iframeWrapper;

            myQuizModel = new QuizModel(data, vocabs, quizInAnIframe, iframeWrapper);
            myQuizView  = new QuizView('.quiz-content', vocabs, myQuizModel.feedback, quizInAnIframe);

            if (quizInAnIframe) {
                news.$('body').addClass('quiz-body-padding-reset');
                iframeWrapper.markPageAsLoaded();
            }

            if (news.isInTheNewsApp) {
                news.$('body').addClass('quiz-body-padding-reset');
                require(['bbcVjAppManager'], function (appManager) {
                    appManager.init(function () {
                        appManager.pageLoaded();
                    });
                });
            }

            utils.setupShare(vocabs, quizInAnIframe, iframeWrapper);
            news.$('.quiz').addClass('quiz_service--' + vocabs.service);
        },
    };
});

